// Engelse teksten van de to-do's in de ouderapp (zie todoApp.nl.ts).
export const appTodoEn = {
    tab: 'To-dos',
    repeatOption: 'No date (to-do)',
    repeatHint: 'No date or time. The to-do stays until it is done.',
    description: 'Details (optional)',
    dueDate: 'Done by (optional)',
    dueClear: 'No end date',
    from: 'from {name}',
    due: 'by {date}',
    emptyTitle: 'No to-dos',
    emptyBody: 'A to-do has no date or time and stays until it is done. For example: paint the shoe cupboard.',
    add: 'Add to-do',
    doneSection: 'Done',
    doneOn: 'done on {date}',
    newTitle: 'New to-do',
    editTitle: 'Edit to-do',
    important: 'Important',
    importantHint: 'Shown at the top, with a small marker.',
    assign: 'Assign to',
    assignHint: 'Babies and toddlers do not get to-dos.',
    assigned: 'Assigned to {names}',
    // Oprichter 6 okt: privé to-do's in Mijn omgeving en de kaart op Vandaag.
    privateNote: 'Only you see these to-dos. Not your family, not the board. Something only appears on the board if you explicitly confirm that yourself for a tablet; you can always take it off again.',
    privateEntry: 'A private to-do? Make it in My space. Only you see it there.',
    privateEntryButton: 'Go to My space',
    gateTitle: 'Your own to-dos',
    gateBody: 'Your own to-dos are in My space. Only you see them: not your family, not the board. Something only appears on the board if you explicitly confirm that yourself for a tablet; you can always take it off again.',
    gateOpen: 'Open My space',
    gateOpening: 'Opening…',
    widgetEmpty: 'No open to-dos.',
    widgetAll: 'All to-dos',
    widgetMore: '+{count} more',
    widgetFrom: 'From {name}, read only',
    widgetOpenIn: 'Open in {name}',
    widgetPending: 'Waiting for approval',
};
//# sourceMappingURL=todoApp.en.js.map